import { space, tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`
export const FilterItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`
export const FilterLabel = styled(Typography)`
  ${Typography.modVariant('body-m-bold-tight')}
  color: ${tok('semantics_content_color')};
`
export const FilterDescription = styled(Typography)`
  ${Typography.modVariant('body-m-regular-snug')}
  color: ${tok('semantics_content_color')};
`
export const FilterOptionValue = styled(Typography)`
  ${Typography.modVariant('body-m-regular-tight')}
  color: ${tok('semantics_content_color')};
`
export const FilterOptionHelpText = styled(Typography)`
  ${Typography.modVariant('body-s-regular-tight')}
  color: ${tok('semantics_content_secondary_color')};
`
export const FilterOptionPrice = styled(Typography)`
  ${Typography.modVariant('body-s-regular-tight')}
  color: ${tok('semantics_content_secondary_color')};
  white-space: nowrap;
`
export const FilterItemOptionWrapper = styled.label`
  cursor: pointer;
`
export const FilterItemOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${space('primitives_space_12')};
`
export const FilterItemOptionContent = styled.div`
  display: flex;
  flex-direction: column;
`
export const FilterItemOptionControl = styled.div`
  align-self: self-start;
`
export const FilterItemOptionTrailing = styled.div`
  margin-left: auto;
`
